import {
  ReactElement,
  JSXElementConstructor,
  ReactFragment,
  ReactPortal,
  ReactNode,
} from "react";
import { ToastContentProps, toast } from "react-toastify";

export const toastService = {
  success: (
    message:
      | string
      | number
      | boolean
      | ReactElement<any, string | JSXElementConstructor<any>>
      | ReactFragment
      | ReactPortal
      | ((props: ToastContentProps<unknown>) => ReactNode)
      | null
      | undefined,
    options = {}
  ) => {
    return toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2000,
      toastId: "1",
      ...options,
    });
  },

  error: (
    message:
      | string
      | number
      | boolean
      | ReactElement<any, string | JSXElementConstructor<any>>
      | ReactFragment
      | ReactPortal
      | ((props: ToastContentProps<unknown>) => ReactNode)
      | null
      | undefined,
    options = {}
  ) => {
    return toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2000,
      toastId: "1",
      ...options,
    });
  },

  // you can add more types of toasts (info, warning, etc) here.
};
